@if (report(); as item) {
  <div class="page-header evaluation-report-header">
    <div>
      <a class="report-back-link" [routerLink]="['/drivers', item.driverId]">← Zurück zur Fahrerakte</a>
      <span class="report-eyebrow">Auswertung · Modul {{ item.moduleNumber }}</span>
      <h1>{{ reportTitle() }}</h1>
      <p>{{ item.driverName }} · {{ item.courseTitle }}</p>
    </div>
    <div class="report-summary-badge">
      <strong>{{ visibleAttempts().length }}</strong>
      <span>{{ visibleAttempts().length === 1 ? 'Fehlversuch' : 'Fehlversuche' }}</span>
    </div>
  </div>

  <section class="panel evaluation-report-intro">
    <div>
      <span class="report-kicker">Detaillierter Bericht</span>
      <h2>Fehler gezielt nachvollziehen</h2>
      <p>Aufgeführt sind die falsch beantworteten Fragen aus jedem nicht bestandenen Versuch – mit der gegebenen und der korrekten Antwort.</p>
    </div>
    @if (lessonId() !== null || finalOnly()) {
      <a class="ghost-button as-link" [routerLink]="['/drivers', item.driverId, 'evaluations', item.enrollmentId]">Alle Fehlversuche anzeigen</a>
    }
  </section>

  <div class="evaluation-attempt-list">
    @for (attempt of visibleAttempts(); track attempt.type + '-' + attempt.id; let attemptIndex = $index) {
      <article class="panel evaluation-attempt-card">
        <header>
          <div class="attempt-number">{{ attemptIndex + 1 }}</div>
          <div>
            <span>{{ attempt.type === 'FINAL' ? 'Modulabschluss' : 'Lektionsquiz' }}</span>
            <h2>{{ attempt.title }}</h2>
            <p>{{ formatAttemptDate(attempt.attemptedAt) }}</p>
          </div>
          <div class="attempt-score">
            <span>Ergebnis</span>
            <strong>{{ score(attempt.scorePercent) }}</strong>
            <small>Nicht bestanden</small>
          </div>
        </header>

        <div class="failed-question-list">
          @for (question of attempt.failedQuestions; track question.questionId; let questionIndex = $index) {
            <section class="failed-question-card">
              <div class="question-index">Frage {{ questionIndex + 1 }}</div>
              <h3>{{ question.questionText }}</h3>
              <div class="answer-comparison">
                <div class="given-answer">
                  <span>Gegebene Antwort</span>
                  <strong><span aria-hidden="true">×</span> {{ question.selectedAnswer }}</strong>
                </div>
                <div class="correct-answer">
                  <span>Richtige Antwort</span>
                  <strong><span aria-hidden="true">✓</span> {{ question.correctAnswer }}</strong>
                </div>
              </div>
              @if (question.explanation) {
                <p class="answer-explanation"><strong>Erklärung:</strong> {{ question.explanation }}</p>
              }
            </section>
          } @empty {
            <p class="empty">Zu diesem Fehlversuch sind keine einzelnen Antworten gespeichert.</p>
          }
        </div>
      </article>
    } @empty {
      <section class="panel empty evaluation-empty">Für diese Auswahl liegen keine Fehlversuche vor.</section>
    }
  </div>
} @else if (loading()) {
  <section class="panel empty">Auswertungsbericht wird geladen …</section>
} @else {
  <section class="panel empty">{{ error() }}</section>
}
